export * as com from './lexicons/com.js'
export * as app from './lexicons/app.js'
export * as chat from './lexicons/chat.js'
export * as tools from './lexicons/tools.js'
